
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/brands/[brandSlug]",
      function () {
        return require("private-next-pages/products/brands/[brandSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/brands/[brandSlug]"])
      });
    }
  